import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
// Antd Components
import { Modal, message, Input } from "antd";

// Actions
import instance from "@/store/actions/instance";

class NewCustomReasonModal extends Component {
  state = {
    saveLoading: false,
    customReason: "",
  };

  addCustomReason = async () => {
    this.setState({ saveLoading: true });
    const { t } = this.props;
    const { customReason } = this.state;
    try {
      const res = await instance.post("/custom_reasons/", {
        name: customReason,
      });

      message.success(t("Added successfully"));
      this.props.addCudstomReasonoList(res.data);

      this.props.onClose(res.data.id);
    } catch (err) {
      console.error(err);
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    this.setState({ saveLoading: false });
  };

  saveButtonDisabled = () => {
    const s = this.state;
    return !s.customReason;
  };

  render() {
    const { visible, t, config } = this.props;

    return (
      <>
        <Modal
          style={{ top: 20 }}
          destroyOnClose={true}
          title={
            <div
              className="ant-modal-title"
              style={{
                textAlign: config.direction == "rtl" ? "right" : "left",
              }}
            >
              {t("New Cancelation Reason")}
            </div>
          }
          visible={visible}
          onCancel={() => this.props.onClose()}
          onOk={() => {
            this.addCustomReason();
          }}
          okButtonProps={{
            disabled: this.saveButtonDisabled(),
            loading: this.state.saveLoading,
          }}
          okText={t("Save")}
          cancelText={t("Close")}
          bodyStyle={{
            paddingTop: 0,
            width: "auto",
            padding: "0px 18px",
            textAlign: config.direction == "ltr" ? "left" : "right",
          }}
        >
          <div className="px-2 mb-3">
            <div>
              <p className="mt-3">{t("Cancelation Reason")}</p>
              <Input
                max={50}
                placeholder={t("Cancelation Reason")}
                onChange={(e) =>
                  this.setState({ customReason: e.target.value?.trim() })
                }
              />
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    settings: state.auth.settings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addCudstomReasonoList: (data) =>
      dispatch({
        type: "ADD_CUSTOM_REASONS",
        payload: data,
      }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(NewCustomReasonModal));
